module.exports = __webpack_public_path__ + "assets/GTAmerica-ExtendedBlack.woff";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExtendedBlack.woff
// module id = 1008
// module chunks = 19